import React from 'react';
import {Button, Card, Flex, Image, Typography} from 'antd';
import {smallLauncherCard} from '../common/styles';
import {PublicEventDTO} from '../../home/types';
import dayjs from "dayjs";
import {CalendarOutlined, ExportOutlined, PushpinOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

interface SmallEventCardProps {
    event: PublicEventDTO;
}

export const SmallEventCard: React.FC<SmallEventCardProps> = ({event}) => {
    const {t} = useTranslation();
    return (
        <Card
            style={smallLauncherCard}
            cover={
                event.mediaUrl ? (
                    <Image
                        alt={event.title}
                        src={event.mediaUrl}
                        preview={false}
                        style={{ height: 100, objectFit: 'cover' }}
                    />
                ) : undefined
            }
            size="small"
        >
            <Card.Meta
                title={<Typography.Text strong ellipsis={{tooltip: event.title}}>{event.title}</Typography.Text>}
                description={
                    <Flex vertical gap="small" style={{marginTop: 8}}>
                        <Flex gap="small" align="center">
                            <CalendarOutlined />
                            <Typography.Text type="secondary" style={{fontSize: '0.8em'}}>
                                {dayjs(event.startsAt).format('DD/MM/YYYY')}
                            </Typography.Text>
                        </Flex>
                        <Flex gap="small" align="center">
                            <PushpinOutlined />
                            <Typography.Text type="secondary" ellipsis={{tooltip: event.location}} style={{fontSize: '0.8em'}}>
                                {event.location}
                            </Typography.Text>
                        </Flex>
                        <Flex gap="small" align="start" justify={"start"}>
                            <Button type="link" href={`/reserve/${event.tag}`} icon={<ExportOutlined />}>
                                {t('event.view')}
                            </Button>
                        </Flex>
                    </Flex>
                }
            />
        </Card>
    );
};
